/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const StarFilled: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="star-filled" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M680 350.8233333333333L1064.88 118.49L962.7666666666668 556.3533333333335L1302.7666666666667 850.9066666666668L854.9866666666667 888.8733333333334L680 1301.9166666666667L505.0133333333334 888.9300000000001L57.1766666666667 850.9633333333334L397.2333333333334 556.2966666666667L295.1200000000001 118.49L680.0000000000001 350.8233333333335z" : "M544 280.6586666666666L851.9040000000001 94.792L770.2133333333335 445.0826666666667L1042.2133333333334 680.7253333333333L683.9893333333334 711.0986666666668L544 1041.5333333333333L404.0106666666668 711.144L45.7413333333334 680.7706666666666L317.7866666666668 445.0373333333333L236.0960000000001 94.792L544.0000000000001 280.6586666666667z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
StarFilled.displayName = `Blueprint5.Icon.StarFilled`;
export default StarFilled;
